/*
Plastic Buckets / Metal Cans
*/
import filters from '@/modules/standardItems/schemas/finish/filters'
import headers from '@/modules/standardItems/schemas/finish/headers'
import form from '@/modules/standardItems/schemas/finish/form'

const name = 'Plastic Buckets / Metal Cans'
const id = 'fPWv6HJmrVIqXQxPfI0B'

export default {
  name,
  id,
  filters,
  headers,
  form
}
